import { createContext } from "react";
import { ICorporateDashboardContext } from "./CorporateDashboardContextInterfaces";
import { initialCorporateDashboardFiltersContext } from "pages/Corporate/CorporateDashboard/useCorporateDashboardFilters";

export const initialState: ICorporateDashboardContext = {
    filters: initialCorporateDashboardFiltersContext,
    showFilters: false,
    totalDowntimeSeconds: undefined,
    handleSetTotalDowntimeSeconds: () => {},
    showOrHideFilters: () => {},
    handleSetFilters: () => {},
    handleSetSelectedFailureType: () => {},
    selectedFailureType: undefined,
    handleSetSelectedFailureCode: () => {},
    selectedFailureCode: undefined,
    handleSetSelectedSecondaryFailureCode: () => {},
    selectedSecondaryFailureCode: undefined,
    resetSelections: () => {},
    corporationCountryCode: "",
    handleSetCorporationCountryCode: () => {},
    handleSetFiltersDefault: async () => {},
    handleRemoveDefaultFilters: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
};
export const CorporateDashboardContext = createContext(initialState);
